import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Home from './containers/home';
import MyPresentations from './containers/my-presentations';
import MySchedule from './containers/my-schedule'
import MyVideos from './containers/my-videos';
import NewVideos from './containers/new-videos';
import WatchVideo from './containers/watch-video';
// import Test from './containers/test';
import VideoEditor from './test/VideoEditor';
import VideoPage from './containers/video-page';
import Tutorial from './containers/tutorial';
import PublicWatch from './containers/public-watch';

import QuizLiveScreen from "./containers/quiz-live-screen";
import QuizModerator from './containers/quiz-moderator';
import QuizAnswerResults from './containers/answer-results';
import QuizAnswerPodium from './components/speaker-mode/quiz-answer-podium';
import QuizFinalPodium from './components/speaker-mode/quiz-final-podium';
import QuizLogin from './components/quiz-attendee/quiz-login';
import QuizIntro from './components/quiz-attendee/quiz-intro';
import QuizLiveUserScreen from './containers/quiz-live-user-screen';
import QuizAnswersWithLeaderBoard from './containers/quiz-answers-with-leaderboard';
import QuizQuestions from './components/speaker-mode/quiz-questions';
import PodiumContainer from "./components/screen-mode/podium-container";
import Try from './test2/Try';
import WrappedChapterEditorMain from './VideoEditor/WrappedChapterEditorMain';
import Test from './test2/Test';
import Synopsis from './containers/Synopsis/synopsis';
// import Test from './test2/test';



type RoutesProps = {
  locale: string; // or a more specific type if you have one
  setLocale: (locale: string) => void; // a function accepting a string and returning void
  socket: any; // Replace `any` with the correct socket type if available
};

const Routes: React.FC<RoutesProps> = ({ locale, setLocale, socket }) => {

  return <Router>

    <Switch>

      {/* <Route exact path="/:event_slug/test/:presentation_id" render={(props) => <Try />} /> */}
      <Route exact path="/:event_slug/test/:presentation_id" render={(props) => <Test />} />
      <Route exact path="/:event_slug/videoeditor/:presentation_id" render={(props) => <WrappedChapterEditorMain locale={locale} setLocale={setLocale}/>} />

      <Route exact path="/:event_slug/synopsis" render={(props) => <Synopsis locale={locale} setLocale={setLocale} {...props} />} />
      <Route exact path="/:event_slug/my-presentations" render={(props) => <MyPresentations locale={locale} setLocale={setLocale} {...props} />} />
      <Route exact path="/:event_slug/my-schedule" render={(props) => <MySchedule locale={locale} setLocale={setLocale} {...props} />} />

      <Route exact path="/:event_slug/my-presentations/:presentation_id" render={(props) => <MyVideos locale={locale} setLocale={setLocale} {...props} />} />
      <Route exact path="/:event_slug/my-presentations/:presentation_id/videos" render={(props) => <NewVideos locale={locale} setLocale={setLocale} {...props} />} />
      <Route exact path="/:event_slug/my-presentations/:presentation_id/video/:version_id/watch" render={(props) => <WatchVideo locale={locale} setLocale={setLocale} {...props} />} />
      <Route exact path="/:event_slug/my-pres/:presentation_id/video/:version_id/watch" render={(props) => <PublicWatch locale={locale} setLocale={setLocale} {...props} />} />
      <Route exact path="/:event_slug" render={(props) => <Home locale={locale} setLocale={setLocale} {...props} />} />

      {/* <Route exact path="/:event_slug/:module?" render={(props) => <Home locale={locale} setLocale={setLocale} {...props} />}  /> */}

      <Route exact path="/:event_slug/:presentation_id/:module?" render={(props) => <VideoPage locale={locale} setLocale={setLocale} socket={socket}  {...props} />} />

      <Route exact path="/:event_slug/:presentation_id/podium/:question_id" render={(props) => <PodiumContainer screen={false} locale={locale} setLocale={setLocale} {...props} />} />

      <Route exact path="/:event_slug/:presentation_id/screen-podium/:question_id" render={(props) => <PodiumContainer screen={true} locale={locale} setLocale={setLocale} {...props} />} />

      {/* <Route exact path="/schedule" component={Schedule} /> */}
      <Route exact path="/:event_slug/tutorial" render={(props) => <Tutorial locale={locale} setLocale={setLocale} {...props} />} />

      {/* <Route exact path="/:event_slug/quiz-user-list"  render={(props) => <QuizHome locale={locale} setLocale={setLocale} {...props} />}   /> */}
      <Route exact path="/:event_slug/quiz-live" component={QuizLogin} />
      <Route exact path="/:event_slug/quiz-questions" component={QuizQuestions} />
      <Route exact path="/:event_slug/answers" component={QuizAnswerResults} />
      <Route exact path="/:event_slug/podium" component={QuizAnswerPodium} />
      {/* <Route exact path="/:event_slug/quiz-moderator" component={QuizModerator} /> */}

    </Switch>
  </Router>
}


export default Routes;
